// extracted by mini-css-extract-plugin
module.exports = {"content":"ModalErrorMessage_content__1a8Nj","title":"ModalErrorMessage_title__2H_G2","button":"ModalErrorMessage_button__26Qic","body":"ModalErrorMessage_body__3yjo9"};